function printReference() {
  window.print();
}

document.addEventListener('DOMContentLoaded', function() {
// Select all elements with the data-send attribute
  const sendButtons = document.querySelectorAll('[data-send]');

  // Add click event listener to each button
  sendButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default link behavior
      
      setTimeout(() => {
        // Get product data from the embedded JSON
        const productData = getCustomerData();
        
        // Fetch cart data
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => { 
            // Create the complete data object
            const completeData = {
              cart: cart,
              customer: productData // Use the product data as customer data
            };

            // Add uom to the complete data cart object from the [data-cws-line-item-variant-id="{{ item.variant.id }}"][data-cws-line-item-uom] element
            completeData.cart.items = completeData.cart.items.map(item => {
              const uomElement = document.querySelector(`[data-cws-line-item-variant-id="${item.variant_id}"][data-cws-line-item-uom]`);
              if (uomElement) {
                const uom = uomElement.textContent.trim();
                return {...item, uom: uom};
              }
              return item;
            });
          
            // You can now use this data for whatever purpose needed
            // For example, logging it or sending it to a server
            handleButtonClick(button.id, completeData);
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
          });
      }, 1000);
    });
  });
  
  
});

// Function to get product data from embedded JSON
function getCustomerData() {
  const customerJsonScript = document.querySelector('[customer-json]');
  if (customerJsonScript) {
    try {
      return JSON.parse(customerJsonScript.textContent);
    } catch (e) {
      console.error('Error parsing product JSON:', e);
      return {};
    }
  }
  return {};
}

// Function to handle button clicks
function handleButtonClick(buttonId, data) {
  console.log(`Button ${buttonId} clicked with data:`, data);
  document.getElementById("loadingOverlay").classList.add("active");

  // Get messaging elements
  const errorMessage = document.querySelector(".error-message");
  const successMessage = document.querySelector(".success-message");

  // Reset messages
  errorMessage.classList.remove("show");
  successMessage.classList.remove("show");

  // Simulate processing delay
  setTimeout(() => {
      document.getElementById("loadingOverlay").classList.remove("active");

      // Toggle the correct message
      if (buttonId === 'send-enquiry' || buttonId === 'send-copy-to-email') {
          successMessage.classList.add("show");

          if (buttonId === 'send-copy-to-email') {
            const hmac = document.getElementById(buttonId).dataset.customerIdHmac;
            sendCartCopyToCustomer(data, hmac).then(null);
          }

          if (buttonId === 'send-enquiry') {
            const hmac = document.getElementById(buttonId).dataset.customerIdHmac;
            sendEnquiry(data, hmac).then(null);
          }
      } else {
          errorMessage.classList.add("show");
      }

      // Hide messages after 3 seconds
      setTimeout(() => {
          successMessage.classList.remove("show");
          errorMessage.classList.remove("show");
      }, 3000);
      
  }, 2000);

  return data;
}

/**
 * Send cart copy to customer email
 */
function sendCartCopyToCustomer(data, hmac) {
  data.customer_id = data.customer.id;
  data.email = data.customer.email;
  data.hmac = hmac;
  return fetch(window.APP_PROXY_PATH + '/send-cart-copy', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
}

/**
 * Send enquiry
 */
function sendEnquiry(data, hmac) {
  data.customer_id = data.customer.id;
  data.email = data.customer.email;
  data.hmac = hmac;
  return fetch(window.APP_PROXY_PATH + '/send-enquiry', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
}

// // Attach event listeners to buttons
// document.querySelectorAll("[data-send]").forEach(button => {
//     button.addEventListener("click", function (event) {
//         event.preventDefault();
//         handleButtonClick(this.id, { exampleData: "some data" });
//     });
// });